import React, { useEffect, useState } from "react";
import axiosClient from "../../axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler, // CHANGE 1: Import the Filler plugin
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler // CHANGE 2: Register the Filler plugin
);

const AreaChart = () => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await axiosClient.get("/api/payments", {
          params: { chart_data: true },
        });
        // Validate response data
        if (!response.data || !Array.isArray(response.data)) {
          throw new Error("Invalid data format received from server");
        }

        // Process data
        const processedData = {
          labels: response.data.map((item) => item.date),
          datasets: [
            {
              label: "Total Payments",
              data: response.data.map((item) => item.total),
              fill: true, // This will now work
              backgroundColor: "rgba(75, 192, 192, 0.2)",
              borderColor: "rgba(75, 192, 192, 1)",
              borderWidth: 2,
              tension: 0.4,
              pointBackgroundColor: "rgba(75, 192, 192, 1)",
              pointRadius: 4,
              pointHoverRadius: 6,
            },
          ],
        };

        setChartData(processedData);
      } catch (error) {
        console.error("Error fetching chart data:", error);
        setError(
          error.response?.data?.message ||
            error.message ||
            "Failed to load chart data"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Chart options
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(0, 0, 0, 0.05)",
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
  };

  return (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title">
          <i className="bi bi-graph-up"></i> Sales Over Time
        </h5>
      </div>
      <div
        className="card-body"
        style={{ height: "300px", position: "relative" }}
      >
        {loading ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : error ? (
          <div className="d-flex justify-content-center align-items-center h-100 text-danger">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            {error}
          </div>
        ) : chartData ? (
          <Line data={chartData} options={chartOptions} />
        ) : (
          <div className="d-flex justify-content-center align-items-center h-100 text-muted">
            No data available
          </div>
        )}
      </div>
    </div>
  );
};

export default AreaChart;
